import axios from "../../config/axiosConfig";
import { CREATE_EWAYBILL_RECHARGE, GET_EWAYBILL_RECHARGE_CUSTOMERS, EWAYBILL_RECHARGE_CUSTOMER_REQUEST, EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL } from "../types";
import { getUsers } from './user-actions';

export const getEwayBillRechargedCustomers = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST });
      const { auth } = getState();
      return axios.get("/eway-bill-recharge/customer-list", { params: { customerId: auth?.user?.Customer_Id }}).then((response) => {
        
        if (response.data) {
          dispatch({ type: GET_EWAYBILL_RECHARGE_CUSTOMERS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error; 
      });      
    } catch (error) {
      console.error(error);
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const ewayBillRechargeCustomer = (user) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST });
      const { auth } = getState();
      return axios.post("/eway-bill-recharge/recharge", user, { params: { userId: auth.superUser?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_EWAYBILL_RECHARGE, payload: response.data });
        } else {
          dispatch({
            type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE,
            error: "Customer create failed.",
          });
        }
        dispatch(getUsers());
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getEwayBillRechargedCustomerDetail = (customerId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST });
      return axios.get("/eway-bill-recharge/customer-detail", { params: { customerId: customerId }}).then((response) => {
        
        if (response.data) {
          dispatch({ type: GET_EWAYBILL_RECHARGE_CUSTOMER_DETAIL, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
        throw error;
      });      
    } catch (error) {
      console.error(error);
      dispatch({ type: EWAYBILL_RECHARGE_CUSTOMER_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

